import { IApplicationInformation } from 'interfaces/i-application-information'
import { ICalculatorCampaign } from 'interfaces/i-calculator-type'

export function CalculateLoanLt(
	loanAmount: number,
	repaymentPeriod: number,
	loanInformation: IApplicationInformation
): {
	openingFee: number
	monthlyFee: number
	interestRate: number
	instalment: number
} {
	let campaign = getValidCampaign(
		loanInformation.offer.campaigns,
		loanAmount,
		repaymentPeriod
	)

	let openingFee,
		monthlyFee,
		interestRate = 0
	if (campaign) {
		openingFee = Math.max(
			campaign.openingFee.minimumAmount ?? 0,
			loanAmount * (campaign.openingFee?.rate ?? 0)
		)
		monthlyFee = Math.max(
			campaign.monthlyFee.minimumAmount ?? 0,
			loanAmount * (campaign.monthlyFee?.rate ?? 0)
		)
		interestRate = campaign.interestRate ?? 0
	} else {
		openingFee = Math.max(
			loanInformation.offer.openingFee.minimumAmount ?? 0,
			loanAmount * (loanInformation.offer.openingFee?.rate ?? 0)
		)
		monthlyFee = Math.max(
			loanInformation.offer.monthlyFee.minimumAmount ?? 0,
			loanAmount * (loanInformation.offer.monthlyFee?.rate ?? 0)
		)
		interestRate = loanInformation.offer.interestRate ?? 0
	}

	//Monthly installment
	let instalment = roundToDecimalUpwards(
		calculateInstallmentLt(
			loanAmount,
			repaymentPeriod,
			openingFee,
			monthlyFee,
			interestRate / 12
		),
		0
	)

	return {
		openingFee: openingFee,
		monthlyFee: monthlyFee,
		interestRate: interestRate,
		instalment: instalment,
	}
}

function getValidCampaign(
	campaigns: ICalculatorCampaign[],
	loanAmount: number,
	repaymentPeriod: number
): ICalculatorCampaign | undefined {
	let validCampaign = undefined
	campaigns.forEach((campaign) => {
		if (
			campaign.minAmount <= loanAmount &&
			loanAmount <= campaign.maxAmount &&
			campaign.minRepaymentPeriod <= repaymentPeriod &&
			repaymentPeriod <= campaign.maxRepaymentPeriod
		)
			validCampaign = campaign
	})
	return validCampaign
}

function calculateInstallmentLt(
	loanAmount: number,
	repaymentPeriod: number,
	openingFee: number,
	monthlyFee: number,
	monthlyInterestRate: number
): number {
	return (
		((loanAmount + openingFee * (1 - monthlyInterestRate)) *
			monthlyInterestRate) /
			(1 - (1 + monthlyInterestRate) ** -repaymentPeriod) +
		monthlyFee
	)
}

function roundToDecimalUpwards(number: number, decimals: number): number {
	const multiplier = Math.pow(10, decimals)
	return Math.ceil(number * multiplier) / multiplier
}
